export default "__VITE_ASSET__DcHsHOIZ__"